var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorrela(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M600 320C600 474.54 474.54 600 320 600C165.46 600 40 474.54 40 320C40 165.46 165.46 40 320 40C474.54 40 600 165.46 600 320Z",
    id: "a2vVS05VLx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 320C640 496.61 496.61 640 320 640C143.39 640 0 496.61 0 320C0 143.39 143.39 0 320 0C496.61 0 640 143.39 640 320Z",
    id: "c3pStP9t"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 40L80 180L80 460L320 600L560 460L560 180L320 40Z",
    id: "aeVue0xEU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.09 110.28L198.61 110L80 318.64L201.86 527.57L442.33 527.86L560.94 319.21L439.09 110.28Z",
    id: "f4y1I9QC4I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 320C560 452.46 452.46 560 320 560C187.54 560 80 452.46 80 320C80 187.54 187.54 80 320 80C452.46 80 560 187.54 560 320Z",
    id: "d5n8iTso6i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 40C340 51.04 331.04 60 320 60C308.96 60 300 51.04 300 40C300 28.96 308.96 20 320 20C331.04 20 340 28.96 340 40Z",
    id: "c1S56amgxJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 180C580 191.04 571.04 200 560 200C548.96 200 540 191.04 540 180C540 168.96 548.96 160 560 160C571.04 160 580 168.96 580 180Z",
    id: "a1AGouSrp9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 460C580 471.04 571.04 480 560 480C548.96 480 540 471.04 540 460C540 448.96 548.96 440 560 440C571.04 440 580 448.96 580 460Z",
    id: "bg0EDKLB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 600C340 611.04 331.04 620 320 620C308.96 620 300 611.04 300 600C300 588.96 308.96 580 320 580C331.04 580 340 588.96 340 600Z",
    id: "fDku74CVh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 460C100 471.04 91.04 480 80 480C68.96 480 60 471.04 60 460C60 448.96 68.96 440 80 440C91.04 440 100 448.96 100 460Z",
    id: "c2BGPLbIKF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 180C100 191.04 91.04 200 80 200C68.96 200 60 191.04 60 180C60 168.96 68.96 160 80 160C91.04 160 100 168.96 100 180Z",
    id: "aEIGZhalA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 110C450 115.52 445.52 120 440 120C434.48 120 430 115.52 430 110C430 104.48 434.48 100 440 100C445.52 100 450 104.48 450 110Z",
    id: "b1icNbOFJ8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 530C450 535.52 445.52 540 440 540C434.48 540 430 535.52 430 530C430 524.48 434.48 520 440 520C445.52 520 450 524.48 450 530Z",
    id: "aGvQ3eQWc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 110C210 115.52 205.52 120 200 120C194.48 120 190 115.52 190 110C190 104.48 194.48 100 200 100C205.52 100 210 104.48 210 110Z",
    id: "e35Drs1jFo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 320C90 325.52 85.52 330 80 330C74.48 330 70 325.52 70 320C70 314.48 74.48 310 80 310C85.52 310 90 314.48 90 320Z",
    id: "b1RAWUUcWW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 530C210 535.52 205.52 540 200 540C194.48 540 190 535.52 190 530C190 524.48 194.48 520 200 520C205.52 520 210 524.48 210 530Z",
    id: "dkJWFAjL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 320C570 325.52 565.52 330 560 330C554.48 330 550 325.52 550 320C550 314.48 554.48 310 560 310C565.52 310 570 314.48 570 320Z",
    id: "a1ob7ZnHni"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 320C520 430.38 430.38 520 320 520C209.62 520 120 430.38 120 320C120 209.62 209.62 120 320 120C430.38 120 520 209.62 520 320Z",
    id: "a4m10G3Sy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 320C440 386.23 386.23 440 320 440C253.77 440 200 386.23 200 320C200 253.77 253.77 200 320 200C386.23 200 440 253.77 440 320Z",
    id: "b1eawJe3wF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "maskbrM6KxtLH",
    x: 120,
    y: 120,
    width: 400,
    height: 400,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 400,
    height: 400,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1eawJe3wF",
    opacity: 1,
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400 320C400 364.15 364.15 400 320 400C275.85 400 240 364.15 240 320C240 275.85 275.85 240 320 240C364.15 240 400 275.85 400 320Z",
    id: "e13oPu5av1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2vVS05VLx",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3pStP9t",
    opacity: 1,
    fill: "#198bed",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aeVue0xEU",
    opacity: 1,
    fill: "#e7eff6",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4y1I9QC4I",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d5n8iTso6i",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1S56amgxJ",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1AGouSrp9",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg0EDKLB6",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fDku74CVh",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2BGPLbIKF",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aEIGZhalA",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1icNbOFJ8",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aGvQ3eQWc",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e35Drs1jFo",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1RAWUUcWW",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dkJWFAjL",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1ob7ZnHni",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4m10G3Sy",
    opacity: 1,
    fill: "#188bed",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1eawJe3wF",
    opacity: 1,
    fill: "#198bed",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskbrM6KxtLH)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1eawJe3wF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 80,
    strokeOpacity: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e13oPu5av1",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrela);
export default __webpack_public_path__ + "static/media/correla.2ed0b48d014bfd027a82e47fc35cdd06.svg";
export { ForwardRef as ReactComponent };